import { NgModule } from '@angular/core';
import { IconButtonModule } from '../../../shared/directives/icon-button/icon-button.module';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { SafePipeModule } from 'safe-pipe';

import { BankAccountFormComponent } from './bank-account-form.component';
import { RnplCommonModule, UIComponentsModule } from 'common/src/modules';

@NgModule({
  declarations: [
    BankAccountFormComponent,
  ],
  imports: [
    IconButtonModule,
    CommonModule,
    ReactiveFormsModule,
    UIComponentsModule,
    RnplCommonModule,
    NgSelectModule,
    TranslateModule,
    SafePipeModule
  ],
  exports: [
    BankAccountFormComponent,
  ],
  providers: []
})
export class BankAccountFormModule { }
